export const DataBreakpoint = {
  small: 375,
  medium: 640,
  large: 1024,
  extraLarge: 1440,
};
